module.exports = __webpack_public_path__ + "assets/img/26_875_big.563fd32f.jpg";